/**
 * @module mapbs.components.reportpanel.simplereport.simplereport
 */

import angular from 'angular';

import mapbsReportService from 'mapbs/components/reportpanel/service/reportservice';

const moduleSimplereport = angular.module('mapbsSimpleReportModule', [
    mapbsReportService.name,
]);

moduleSimplereport.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/simplereport', require('./simplereport.html'));
    }
);

/** @type {!angular.Component} */
const SimpleReportComponent = {
    controller: 'mapbsSimpleReportController as ctrl',
    templateUrl: 'mapbs/simplereport',
    bindings: {
        'reporttitle': '@mapbsSimplereportTitle',
        'reportdescription': '@mapbsSimplereportDescription',
        'reportlayout': '@mapbsSimplereportLayout',
        'reportPanelActive': '<mapbsSimplereportActive',
    },
};

moduleSimplereport.component('mapbsSimplereport', SimpleReportComponent);

class SimpleReportController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$http} $http
   * @param {mapbsReportService} mapbsReportservice
   * @ngInject
   */
    constructor($scope, $http, mapbsReportservice) {
    /** @type {angular.Scope} @private */
        this.scope = $scope;
        /** @type {angular.$http} @private */
        this.http = $http;
        /** @type {mapbsReportService} @private */
        this.reportService = mapbsReportservice;

        /** @type {string} */
        this.reporttitle = 'not set';

        /** @type {string} */
        this.reportdescription = 'description';

        /** @type {string} */
        this.reportlayout = 'default';

        /** @type {boolean} */
        this.reportPanelActive;

        /** @type {string} */
        this.state = 'inactive';

        /** @type {string} */
        this.downloadurl = '';

        /** @type {string} */
        this.errormessage = '';

        this.scope.$on('tookfocus', (event, name) => {
            if (name !== this.reporttitle) {
                this.setState('inactive');
            }
        });

        this.scope.$watch(
            () => this.reportPanelActive,
            (newVal) => {
                if (!newVal) {
                    this.setState('inactive');
                }
            }
        );
    }

    toggleState() {
        switch (this.state) {
            case 'inactive':
                this.startReport();
                break;
            case 'wait':
                this.setState('inactive');
                break;
            case 'ready':
                this.setState('inactive');
                break;
        }
    }

    setState(state) {
        if (state !== 'inactive') {
            this.scope.$emit('takefocus', this.reporttitle);
        } else {
            this.reportService.cancelReport();
        }
        this.state = state;
    }

    startReport() {
        this.setState('wait');

        this.reportService
      .createReport(this.reportlayout, '1')
      .then(
          this.handleReportSuccess.bind(this),
          this.handleReportError.bind(this)
      );
    }

    handleReportSuccess(url) {
        this.downloadurl = url;
        this.setState('ready');
    }

    handleReportError(error) {
        this.errormessage = error;
        this.setState('error');
    }
}

moduleSimplereport.controller('mapbsSimpleReportController', SimpleReportController);

export default moduleSimplereport;
